import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnChanges, OnInit, SimpleChanges, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { FileService } from 'app/services/file.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'environments/environment';
import { TranslocoPipe } from '@ngneat/transloco';

@Component({
  selector: 'app-drake-file-preview',
  templateUrl: './drake-file-preview.component.html',
  styleUrls: ['./drake-file-preview.component.scss'],
  standalone: true,
  //changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatButtonModule, MatIconModule, HttpClientModule, TranslocoPipe],
  providers: [TranslocoPipe]
})
export class DrakeFilePreviewComponent implements OnChanges {

  @Input() fileId: string = null;
  @Input() heightMode: string = "";
  fileName: string = null;
  fileContentBase64: string = null;
  dataUrl: SafeUrl = null;
  extension: string = null;
  previewType: string = null;

  constructor(private cdRef: ChangeDetectorRef, private fileService: FileService, private sanitizer: DomSanitizer) {

  }

  /*ngOnChanges(changes: SimpleChanges): void {
    //console.log(changes)
    if (changes.fileId?.currentValue) {
      var x = this.fileService.readFileAsBase64String(changes.fileId?.currentValue)
      //console.log(x)
      x.subscribe((res: any) => {
        this.fileContentBase64 = res.fileContentBase64 ? res.fileContentBase64 : null;
        this.fileName = res.fileName;
        this.extension = res.contentType.toString().startsWith('drake') ? "external" : this.fileName.split('.').slice(-1)[0].toLowerCase();
        this.previewType = this.getPreviewType(this.extension);
        if (this.previewType == 'OFFICE') {

          this.dataUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(`${environment.apiUrl}drakeData/GetFileContent/${this.fileId}`));
          console.log("this.dataurl", this.dataUrl);


        }
        else if (res.contentType.toString().startsWith('drake')){
          
          this.dataUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.fileContentBase64);
        }
        else {

          this.dataUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.dataUrl);
        }
      });

    }
  }*/

    ngOnChanges(changes: SimpleChanges): void {

      if (!changes.fileId?.currentValue) {
        return;
      }
    
      this.fileService.readFileAsBase64String(changes.fileId.currentValue)
        .subscribe((res: any) => {
          this.fileName = res.fileName;
          const contentType = res.contentType.toString();
          this.extension = contentType.startsWith('drake')
            ? 'external'
            : this.fileName.split('.').pop().toLowerCase();
          this.previewType = this.getPreviewType(this.extension);
    
          if (this.previewType === 'OFFICE') {
            this.dataUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
              'https://view.officeapps.live.com/op/embed.aspx?src=' +
                encodeURIComponent(
                  `${environment.apiUrl}drakeData/GetFileContent/${this.fileId}`
                )
            );
            return;
          }
    
          if (contentType.startsWith('drake')) {
            this.dataUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
              res.fileContentBase64
            );
            return;
          }
    
          let base64 = res.fileContentBase64 || '';
          const dataUriMatch = base64.match(/^data:[^;]+;base64,(.*)$/);
          if (dataUriMatch) {
            base64 = dataUriMatch[1];
          }
    
          let byteArray: Uint8Array;
          try {
            const binary = atob(base64);
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i++) {
              bytes[i] = binary.charCodeAt(i);
            }
            byteArray = bytes;
          } catch (err) {
            console.error('Base64 decode failed', err);
            alert('Anteprima non disponibile: contenuto non valido o corrotto.');
            return;
          }
    
          const blob = new Blob([byteArray], { type: contentType });
          const url = URL.createObjectURL(blob);
          this.dataUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    
          //URL.revokeObjectURL(url);
          this.cdRef.markForCheck();
        });
    }
    
    

  getPreviewType(ext: string) {
    switch (ext) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'webm':
      case 'bmp':
        return "IMAGE";

      case 'doc':
      case 'dot':
      case 'docx':
      case 'dotx':
      case 'xls':
      case 'xlt':
      case 'xla':
      case 'xlsx':
      case 'xltx':
      case 'xlsm':
      case 'ppt':
      case 'pptx':
        return "OFFICE";

      case "pdf":
        return "EMBED";

      case "external":
        return "EXTERNAL";

      default:
        return "GENERIC";

    }

  }
}
